/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ERRORS } from './Error.constants';
import { ErrorWithHttpStatusCode } from './ErrorWithHttpStatusCode';

/**
 * Internal server error (500).
 * @export
 * @class InternalServerError
 * @extends {ErrorWithHttpStatusCode}
 */
export class InternalServerError extends ErrorWithHttpStatusCode {
  constructor(
    public details: string,
    message = ERRORS.internalServerError.name,
  ) {
    super(ERRORS.internalServerError.code, message, details);
  }
}
